





















































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetDicTempsByType} from "@/api/systemBasic"
import {GetPatientList} from "@/api/patient"
import {SaveShiftBorad} from "@/api/dialysisProcess"

@Component({
	components: {}
})
export default class ShiftBoard extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any
	loading = false
	patients: any = []
	temps: any = []
	dates:any = []
	defaultMb = {title:'不使用模板',content:''}
	model: any = {
		patientId: '',
		priorityLevel: '低',
		overType: '其他',
		mb: '不使用模板',
		overDate: new Date(),
		overContent:''
	}

	created() {
		this.init()
	}

	async save() {
		(this.$refs.form as any).validate(async (valid: boolean) => {
			if (valid) {
				this.model.overDate = (this.model.overDate as Date).Format('yyyy-MM-dd HH:mm')
				let res = await SaveShiftBorad(this.model)
				if (res.status === 1) {
					this.$emit('save-success')
				}
			}
		})

	}
	mbCheck(item:any){
		this.model.mb = item.title
		this.model.overContent = item.content
	}
	rules = {
		patientId: [{required: true, message: this.L('FieldIsRequired')}],

	}

	cancel() {
		this.$emit('input', false)
	}
	timeChange(val1:any, val2:any){
		this.dates = val1
	}
	get dialogTitle() {
		return (this.data.mode === 'add' ? '新增' : '编辑') + "交班记录"
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	private async init() {
		this.loading = true
		let res = await GetDicTempsByType({type: '004'})
		this.temps = res.objects
		let res2 = await GetPatientList()
		this.patients = res2.objects
		this.loading = false

	}


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/roomManage/shiftBoard/addOrEdit.vue